import { useRouter } from 'next/router';
import { useMemo } from 'react';

import Button from '~components/Button';
import { WEB_URL } from '~constant/env';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useMedia from '~hooks/useMedia';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

import ButtonGroup from '../ButtonGroup';
import Legends from '../Legends';
import * as S from './style';

interface Props {
  companyId: string;
}

export default function SignupNudgeSalaryChart({ companyId }: Props) {
  const router = useRouter();
  const { isMobile } = useMedia();
  const moveOneIdPage = useMoveOneIdPage();
  const { data } = useGetCompanyInfo(companyId);
  const videoAssetName = useMemo(() => {
    if (isMobile) {
      return 'video-chart-salary-m';
    }

    return 'video-chart-salary';
  }, [isMobile]);

  const handleClick = () => {
    setGtmDataLayer('company__salary__login__click', {
      companyHash: data?.PK_NM_HASH,
      companyName: data?.name,
      graphType: '인원 월별',
    });

    moveOneIdPage({
      beforeUrl: `${WEB_URL}${router.asPath}#salary-linechart`,
      messageKey: 'kreditjob_company_bookmark_title',
    });
  };

  return (
    <S.Wrapper onClick={() => handleClick()}>
      <Legends />
      <S.VideoWrapper>
        {videoAssetName && (
          <S.Video key={videoAssetName} autoPlay loop muted playsInline>
            <source
              key={`/images/${videoAssetName}.webm`}
              src={`/images/${videoAssetName}.webm`}
              type='video/webm'
            />
            <source
              key={`/images/${videoAssetName}.mp4`}
              src={`/images/${videoAssetName}.mp4`}
              type='video/mp4'
            />
          </S.Video>
        )}

        <S.MessageWrapper>
          <S.Message>
            {data?.name}의<br />
            평균급여 추이가 궁금하다면?
          </S.Message>
          <Button variant='magenta' size='sm'>
            로그인
          </Button>
        </S.MessageWrapper>
      </S.VideoWrapper>
      <ButtonGroup currentYear={3} />
    </S.Wrapper>
  );
}
